import React from "react";
const { List, Map, fromJS } = require('immutable');

export const pathTraverse = (object, path) => {
    let array = path.split('.');
    let item = object;
    array.forEach((property) => {
        if (item !== null & item !== undefined) item = item[property];
    });

    return item;
};

export const displayErrors = (errors, path, opts = {}) => {
    let item = pathTraverse(errors, path);
    if (Array.isArray(item)) {
        return (
            <small className='shift text-danger'>
                <ul>
                    { item.map((error, index) => (<li key={index}>{ opts['name'] ? `${opts['name']} ` : '' }{ error }</li>)) }
                </ul>
            </small>
        );
    }
    return item ? (<small className="shift form-text text-danger">{ opts['name'] ? `${opts['name']} ` : '' }{item}</small>) : null;
};

export const withTouchedError = (errors, touched, path) => {
    let error = pathTraverse(errors, path);
    let touch = pathTraverse(touched, path);
    return error && touch;
};

export const withTouchedErrorClass = (errors, touched, path) => {
    return (withTouchedError(errors, touched, path) ? 'form-control error' : 'form-control');
};


export const parseNestedAttributesErrors = (errors, nestedName) => {
    let attribute = nestedName + '.';
    let attributeErrors = {};

    Object.keys(errors).map((key, index) => {
        if (key.startsWith(attribute)) {
            let nestedName = key.replace(attribute,'');
            attributeErrors[nestedName] = errors[key];
            delete errors[key];
        }
    });

    errors[nestedName] = attributeErrors;
    return errors;
};

export const parsePropertiesErrors = (errors, path) => {
    let nested = fromJS(errors);
    const pathArray = path.split('.');

    nested = nested.updateIn(pathArray, (value) => {
        if (List.isList(value)) {
            let propertiesErrors = {};
            value.forEach((error, index) => {
                if (Map.isMap(error)) {
                    propertiesErrors[error.get('field')] = error.get('message');
                }
            });
            return propertiesErrors;
        } else {
            return undefined;
        }
    });

    return nested.toJS();
};
